import React from 'react';
import './HowWeHelp.css'
import { GiBarrier} from 'react-icons/gi'

const TeamBuildingAndAnalytics = () => {
    return (  
        // <>
        //     <GiBarrier  size={250} style={{marginLeft:"42%"}}/>
        //     <div style={{textAlign:"center"}}>This Page is under Construction.....</div>
        // </>
        <></>
    );
}
 
export default TeamBuildingAndAnalytics;